import {MutationTree} from 'vuex';
import {DatapointsState} from '@/store/modules/datapoints/index';

export const mutations: MutationTree<DatapointsState> = {

}
